import { Component, OnInit, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.css']
})
export class CardComponent implements OnInit {

  @Input('title')title: string;
  @Input('subtitle')subtitle: string;
  @Input('ico')ico: string;
  @ViewChild('content')contentRef;
  public hasContent = false;
  public hasHeadling = false;

  constructor() {

  }

  ngOnInit() {
    this.hasContent = !!this.contentRef.nativeElement.innerHTML.trim();
    this.hasHeadling = (!!this.title || !!this.ico || !!this.subtitle);
  }

}



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/shared/card/card.component.ts